export default {
  'attachment.search.name.placeholder': '请输入关键字，如目录/名称',
  'attachment.search.createby.placeholder': '请选择创建者',
  'attachment.table.select': '选择',
  'attachment.table.createby': '创建人',
  'attachment.table.createTime': '创建时间',
  'attachment.table.dir': '目录',
};
